import NTopNBottom from "../../components/NTopNBottom";
// 主图
import bannerImg from "../../assets/garden/banner.jpg";
import navColor from "../../assets/garden/nav/color.png";
// 背景
import navBg from "../../assets/garden/nav/nav_bg.png";
// 定位背景
import navBgFixed_1 from "../../assets/garden/nav/nav_fix1.png";
// 标题选中文字
import far1 from "../../assets/garden/nav/top1_far1.png";
import far1_active from "../../assets/garden/nav/far1_active.png";
import far2 from "../../assets/garden/nav/top1_far2.png";
import far2_active from "../../assets/garden/nav/far2_active.png";
import far3 from "../../assets/garden/nav/top1_far3.png";
import far3_active from "../../assets/garden/nav/far3_active.png";
import top1_son1 from "../../assets/garden/nav/top1_son1.png";
import top1_son1_active from "../../assets/garden/nav/top1_son1_active.png";
import top1_son2 from "../../assets/garden/nav/top1_son2.png";
import top1_son2_active from "../../assets/garden/nav/top1_son2_active.png";
import top2_son1 from "../../assets/garden/nav/top2_son1.png";
import top2_son1_active from "../../assets/garden/nav/top2_son1_active.png";
import top2_son2 from "../../assets/garden/nav/top2_son2.png";
import top2_son2_active from "../../assets/garden/nav/top2_son2_active.png";
import top3_son1_active from "../../assets/garden/nav/top3_son1_active.png";
import calcRemFn from "../calcRem";

let navCss = {
  navWrap: {
    minHeight: calcRemFn(193.5),
    backgroundImage: `url(${navColor})`,
    boxSizing: "border-box",
    marginTop: calcRemFn(0)
  },
  navCtn: {
    height: calcRemFn(200),
    backgroundImage: `url(${navBg})`
  },
  navCtnFixed: {
    margin: `${calcRemFn(-10)} 0 0 0`,
    height: calcRemFn(200),
    backgroundImage: `url(${navBgFixed_1})`
  },
  topBtnLayout: {
    padding: `${calcRemFn(28)} ${calcRemFn(54)} ${calcRemFn(0)}`,

  },
  topBtnBaseCss: {
    width: calcRemFn(85),
    height: calcRemFn(40),
    marginTop: calcRemFn(10),
    opacity: 0
  },
  bottomBtnLayout: {
    padding: `${calcRemFn(0)} ${calcRemFn(120)} ${calcRemFn(0)}`,
    'justify-content': 'center'
  },
  bottomBtnBaseCss: {
    width: calcRemFn(40),
    height: calcRemFn(20),
    margin: `0 ${calcRemFn(45)}`,
    marginTop: `${calcRemFn(5)}`
  },
  thirdBtnLayout: {
    marginTop: calcRemFn(7),
    height: calcRemFn(50),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexWrap: "wrap",
    padding: `${calcRemFn(12)} ${calcRemFn(50)} ${calcRemFn(20)}`,
    paddingBottom: 0
  },
  thirdBtnBaseCss: {
    width: calcRemFn(55),
    height: calcRemFn(30),
    margin: `0 ${calcRemFn(5)}`
  }
};

const navData = {
  // 三级分隔符控件
  showLine3: true,
  component: NTopNBottom,
  top: [
    {
      key: "top1",
      show: true,
      img: far1,
      img_actived: far1_active
    },
    {
      key: "top2",
      show: true,
      img: far2,
      img_actived: far2_active
    },
    {
      key: "top3",
      show: true,
      img: far3,
      img_actived: far3_active
    }
  ],
  bottom: {
    top1: [
      {
        key: "_i1",
        show: true,
        img: top1_son1,
        img_actived: top1_son1_active
      },
      {
        key: "_i2",
        show: true,
        img: top1_son2,
        img_actived: top1_son2_active
      }
    ],
    top2: [
      {
        key: "_i1",
        show: true,
        img: top2_son1,
        img_actived: top2_son1_active
      },
      {
        key: "_i2",
        show: true,
        img: top2_son2,
        img_actived: top2_son2_active
      }
    ],
    top3: [
      {
        key: "_i1",
        show: true,
        img: top3_son1_active,
        img_actived: top3_son1_active
      }
    ]
  }
};

function handleThirdNav (secoundNav) {
  const thirdNavMap = {};
  for (let firstKey in secoundNav) {
    const navs = secoundNav[firstKey];
    navs.forEach(item => {
      const thirdKey = firstKey + item.key;
      if (firstKey === "top1") {
        if (item.key === "_i1") {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_1.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_1_active.png`),
            },
            {
              key: "_t2",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_2.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_2_active.png`),
            },
            {
              key: "_t3",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_3.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_3_active.png`),
            },
            {
              key: "_t4",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_4.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_4_active.png`),
            },
            {
              key: "_t5",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_5.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_5_active.png`),
            },
            {
              key: "_t6",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_6.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_6_active.png`),
            }
          ]
        } else {
          thirdNavMap[thirdKey] = [
            {
              key: "_t1",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_7.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_7_active.jpg`),
            },
            {
              key: "_t2",
              show: true,
              img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_8.png`),
              img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third1_8_active.jpg`),
            }
          ]
        }

      } else if (firstKey === "top2") {
        thirdNavMap[thirdKey] = [
          {
            key: "_t1",
            show: true,
            img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third2_1.png`),
            img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third2_1_active.png`),
          },
          {
            key: "_t2",
            show: true,
            img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third2_2.png`),
            img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third2_2_active.png`),
          },
          {
            key: "_t3",
            show: true,
            img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third2_3.png`),
            img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third2_3_active.png`),
          }
        ]
      } else if (firstKey === "top3") {
        thirdNavMap[thirdKey] = [
          {
            key: "_t1",
            show: true,
            img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third3_1.png`),
            img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third3_1_active.png`),
          },
          {
            key: "_t2",
            show: true,
            img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third3_2.png`),
            img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third3_2_active.png`),
          },
          {
            key: "_t3",
            show: true,
            img: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third3_3.png`),
            img_actived: require(`@/pages/ThemePage/views/themeApage/assets/garden/nav/third3_3_active.png`),
          }
        ]
      }
    });
  }
  return thirdNavMap;
}

navData.third = handleThirdNav(navData.bottom);
const pictureList = [];
function handlePictures (pictureList) {
  const pictures = [];
  const pictureListLopp = {
    '1_1': { num: [2, 2, 2, 2, 2, 3], prodId: 99422 },
    '1_2': { num: [2,2], prodId: 99422 },
    '2_1': { num: [2, 2, 2], prodId: 99423 },
    '2_2': { num: [2,2,2], prodId: 107399 },
    '3_1': { num: [2,4,5], prodId: 99426 }
  }
  for (const key in pictureListLopp) {
    const element = pictureListLopp[key];
    element.num.forEach((item, idx) => {
      pictureList.push({
        key: key + '_' + (idx + 1),
        picNum: item,
        pid: element.prodId
      })
    })
  }
  pictureList.forEach(item => {
    const { picNum, pid, key, startIndex = 0 } = item;
    const picList = [];
    Array(picNum)
      .fill(0)
      .forEach((item, index) => {
        picList.push(
          require(`../../assets/garden/ctn/${key}_${index + startIndex + 1}.jpg`)
        );
      });
    const indexArr = key.split("_");
    pictures.push({
      id: pid,
      type: "blue",
      ref: `top${indexArr[0]}_i${indexArr[1]}_t${indexArr[2]}`,
      farName: `top${indexArr[0]}`,
      sonName: `_i${indexArr[1]}`,
      thirdName: `_t${indexArr[2]}`,
      son: picList
    });
  });
  return pictures;
}
const pictures = handlePictures(pictureList);
pictures.push({
  son: [],
  fun: 'toNewWedding'
})

pictures.push({
  son: [],
  type: "blue",
  ref: `top1_i12_t1`,
  farName: `top1`,
  sonName: `_i1`,
  thirdName: `_t1`,
})
let farBase = 'top1'
function onScroll (actived,vm) {
  const {far,son} = actived;
  if (far === 'top1' && son === '_i1') vm.allData.navCss.navCtnFixed.backgroundImage = `url(${require('../../assets/garden/nav/nav_fix1.png')})`
  if (far === 'top1' && son === '_i2') vm.allData.navCss.navCtnFixed.backgroundImage = `url(${require('../../assets/garden/nav/nav_fix4.png')})`
  if (far !== farBase){
    farBase = far
    if (far === 'top1') {
      vm.allData.navCss.navCtnFixed.backgroundImage = `url(${require('../../assets/garden/nav/nav_fix1.png')})`
      initFar('top1',vm)
    }
    if (far === 'top2') {
      vm.allData.navCss.navCtnFixed.backgroundImage = `url(${require('../../assets/garden/nav/nav_fix2.png')})`
      initFar('top2',vm)
    }
    if (far === 'top3') {
      vm.allData.navCss.navCtnFixed.backgroundImage = `url(${require('../../assets/garden/nav/nav_fix3.png')})`
      initFar('top3',vm)
    }
  }
}
function initFar(far,vm) {
  vm.allData.navData.top.forEach((i,index)=>{
    i.img = require(`../../assets/garden/nav/${far}_far${index + 1}.png`)
  })
}
const topDiff = {
  firstSon: "_i1",
  firstThird: "_t1",
  top4_i1_t1: 30
};

export default {
  title: "超感花园",
  bannerImg,
  navCss,
  navData,
  pictures,
  topDiff,
  onScroll
};
